export const MODAL_TYPE_CREATE_POST = 'create-post';
